var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-secondaire mr-4 action",attrs:{"disabled":_vm.isDisabled,"loading":_vm.isLoading,"outlined":!_vm.isColorBranche,"block":"","color":"primary","elevation":"0","rounded":""},on:{"click":_vm.onClick}},[(_vm.icon)?_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.libelleBtn)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }